import React from 'react';
import {useTranslation} from 'react-i18next';
import {Spinner} from '../../Spinner';
import {ActivityLogEntry} from './ActivityLogEntry';

export function ActivityLogEntryList({entries, loading, clientId}) {
    const {t} = useTranslation();

    if (loading) {
        return (
            <div className="activity-log-empty">
                <Spinner color="positive"/>
            </div>
        );
    }

    if (!entries || entries.length === 0) {
        return (
            <div className="activity-log-empty">
                <i className="fas fa-history"/>
                {t('activity_log.no_entries')}
            </div>
        );
    }

    return (
        <div className="activity-log-entries">
            {entries.map((entry) => (
                <ActivityLogEntry key={entry.id} entry={entry} clientId={clientId}/>
            ))}
        </div>
    );
}
